// imports section Start
import React from "react";
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Typography,
  IconButton,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import AddIcon from "@mui/icons-material/Add";
import no_image from "../../assets/images/no_image.png";
import { useStyles } from "../../assets/styles/Theme";
// imports section End

export default function GuestItemGrid({ addToCart, cartItem, IMAGEBASEURL }) {
  // Hooks
  const theme = useTheme();
  const styles = useStyles(theme);
  const isDarkMode = theme.palette.mode === "dark";

  // Handlers
  const handleAddToCart = () => {
    addToCart(cartItem);
  };

  const formatPrice = (price) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "LKR",
    }).format(price);
  };

  // Render
  return (
    <Card
      sx={{
        borderRadius: 1,
        boxShadow: 2,
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        padding: 2,
      }}
    >
      {/* Image Section */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "2px",
          overflow: "hidden",
          width: "100%",
          height: 150,
          marginBottom: 2,
          backgroundColor: theme.palette.background.tertiary,
        }}
      >
        <CardMedia
          component="img"
          image={
            cartItem.WEBIMAGEPATH
              ? `${IMAGEBASEURL}${cartItem.WEBIMAGEPATH.replace("~", "")}`
              : no_image
          }
          alt={cartItem.MENUNAME || "Product Image"}
          sx={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      </Box>

      {/* Title Section */}
      <CardContent sx={{ textAlign: "left", padding: 0 }}>
        <Typography variant="item_card_title" noWrap>
          {cartItem?.MENUNAME || "No Name"}
        </Typography>
        {/* <Typography variant="body2" color="textSecondary">
          {cartItem?.DESCRIPTION || "Delicious and healthy."}
        </Typography> */}
      </CardContent>

      {/* Info Section */}
      {/* <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginY: 1,
          paddingX: 2,
        }}
      >
        <Typography variant="caption" color="textSecondary">
          {`${cartItem.CALORIES || 60} calories`}
        </Typography>
        <Typography variant="caption" color="textSecondary">
          {`${cartItem.SERVINGS || 4} persons`}
        </Typography>
      </Box> */}

      {/* Price and Add Button */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          // pr: 2,
        }}
      >
        <Typography
          variant="item_card_price"
          sx={{ color: theme.palette.text.secondary }}
        >
          {formatPrice(cartItem.RATE)}
        </Typography>
        <IconButton
          onClick={handleAddToCart}
          sx={{
            boxShadow: 2,
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.text.buttontxt,
            "&:hover": {
              backgroundColor: theme.palette.primary.dark,
            },
          }}
        >
          <AddIcon />
        </IconButton>
      </Box>
    </Card>
  );
}
